import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';

import { CommonService } from '../services/common.service';
import { ShareService } from '../services/share.service';

@Component({
  selector: 'app-turnos',
  templateUrl: './turnos.component.html',
  styleUrls: ['./turnos.component.scss'],
  providers: [CommonService]
})
export class TurnosComponent implements OnInit {
  private counter:number;
  public dayCounter:number;
  public search:any;
  public turnos:any;
  public day;
  public weekday;
  public month;
  public year;

  private currentTurno;
  private currentModal;

  public centros:any[];
  public profesionales:any[];
  public horarios:any[];
  public selectedCentro = 0;
  public selectedProfesional = 0;
  public selectedHorario = 0;
  public selectedDate:Date;
  public minDate:Date;
  public es:any;

  constructor(private commonService:CommonService, 
    private shareService:ShareService,
    private modalService: NgbModal,
    private router:Router) { }

  ngOnInit() {
    this.counter = 0;
    this.dayCounter = 0;
    this.search = this.shareService.getSearch();

    if (!this.search) {
      this.router.navigate(['/inicio']);
      //this.search = {
        //"os":[9999],
        //"especialidad":1,
        //"dia":5,
        //"franja":["Mañana","Tarde"],
        //"barrio":12,
        //"fecha": new Date("2017-07-28T15:03:25.279Z"),
        //"pacientes":{
          //"adultos":[],
          //"menores":[{"nro":1,"os":9999,"apellido":"","dni":"","email":"","nombre":"","telefono":""}]//[{"nro":1,"os":12,"apellido":"","dni":"","email":"","nombre":"","telefono":""}]
        //}
      //}; 
      //this.searchTurnos(false); 
    } else {
      this.searchTurnos(false);
    }
  }

  searchTurnos(isPrev):void {
    this.commonService.searchTurnos(this.search).then(result => {
      this.counter++;

      if (result.length === 0 && this.counter < 8) {
        if (isPrev) {
          this.search.fecha = moment(this.search.fecha).subtract(1,'d').toDate();
        } else {
          this.search.fecha = moment(this.search.fecha).add(1,'d').toDate();
        }

        this.search.dia = moment(this.search.fecha).weekday();

        if (this.search.dia === 6) {
          this.search.fecha = moment(this.search.fecha).add(2,'d').toDate();
          this.search.dia = moment(this.search.fecha).weekday();
        }

        if (this.search.dia === 0 && isPrev) {
          this.search.fecha = moment(this.search.fecha).subtract(2,'d').toDate();
          this.search.dia = moment(this.search.fecha).weekday();
        }

        this.searchTurnos(isPrev);
      } else {
        this.turnos = result;
        this.composeFechas();
      }
    });
  }

  searchNext():void {
    let newDate = moment(this.search.fecha).add(1, 'd');
    this.search.fecha = newDate.toDate();
    this.search.dia = newDate.weekday(); 
    this.dayCounter++;
    this.counter = 0;
    this.turnos = [];
    this.searchTurnos(false);
  }

  searchPrev():void {
    let newDate = moment(this.search.fecha).subtract(1, 'd');
    this.search.fecha = newDate.toDate();
    this.search.dia = newDate.weekday(); 

    if (this.search.dia === 0) {
      this.search.fecha = moment(this.search.fecha).subtract(2,'d').toDate();
      this.search.dia = 5;
    }

    this.dayCounter--;
    this.counter = 0;
    this.turnos = [];
    this.searchTurnos(true);
  }

  composeFechas():void {
    let dias = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
      meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

    this.day = this.search.fecha.getDate();
    this.weekday = dias[this.search.fecha.getDay()];
    this.month = meses[this.search.fecha.getMonth()];
    this.year = this.search.fecha.getFullYear();
  }

  open(content, t, id) {
    if (id) {
      this.currentTurno = id;
    } else {
      this.es = {
        firstDayOfWeek: 0,
        dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
        dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
        dayNamesMin: [ "D","L","M","X","J","V","S" ],
        monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
        monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ]
      };

      this.minDate = new Date();


      Promise.all([
        this.commonService.getCentros(),
        this.commonService.getProfesionales(),
        this.commonService.getHorarios()
      ]).then(result => {
        this.centros = result[0];
        this.profesionales = result[1];
        this.horarios = result[2];
      });
    }

    this.modalService.open(content, {
      backdrop:'static'
    }).result.then(() => {
      if (t === 'turno') {
        this.reservarTurnos();
      } else if (t === 'sobreturno') {
        this.crearSobreTurnos();
      }
    }, () => {
    });
  }

  private reservarTurnos() {
    var turnosToAdd = [],
      c = 0,
      turnoId = this.currentTurno,
      especialidadId = this.search.especialidad,
      fecha = this.search.fecha,
      dateNumber = '' + this.search.fecha.getDate() + this.search.fecha.getMonth() + this.search.fecha.getFullYear();

    this.search.pacientes.adultos.forEach(function(item) {
      var turnoToPush = {
        turnos_del_profesional_id:turnoId,
        fecha:fecha,
        obras_sociales_id:item.os,
        especialidades_id:especialidadId,
        nro_reserva:turnoId + dateNumber + item.dni + item.nro,
        nombre_p:item.nombre,
        apellido_p:item.apellido,
        dni_p:item.dni,
        email_p:item.email,
        telefono_p:item.telefono,
        nombre_ar:'',
        apellido_ar:''
      };

      turnosToAdd.push(turnoToPush);
    });

    this.search.pacientes.menores.forEach(function(item) {
      var turnoToPush = {
        turnos_del_profesional_id:turnoId,
        fecha:fecha,
        obras_sociales_id:item.os,
        especialidades_id:especialidadId,
        nro_reserva:turnoId + dateNumber + item.dni + item.nro,
        nombre_p:item.nombre,
        apellido_p:item.apellido,
        dni_p:item.dni,
        email_p:item.email,
        telefono_p:item.telefono,
        nombre_ar:item.nombre_ar,
        apellido_ar:item.apellido_ar
      };

      turnosToAdd.push(turnoToPush);
    });

    turnosToAdd.forEach(t => {
      this.commonService.saveTurno(t)
        .then(() => {
          c++;

          if (c === turnosToAdd.length) {
            alert('Turnos reservados correctamente');
            this.router.navigate(['/inicio']);
          }
        });
    });
  }

  private crearSobreTurnos() {
    var sobreTurnosToAdd = [],
      c = 0,
      especialidadId = this.search.especialidad,
      selectedProfesional = this.selectedProfesional,
      selectedCentro = this.selectedCentro,
      selectedHorario = this.selectedHorario,
      fecha = this.selectedDate,
      dateNumber = '' + this.search.fecha.getDate() + this.search.fecha.getMonth() + this.search.fecha.getFullYear();

    this.search.pacientes.adultos.forEach(function(item) {
      var sobreTurnoToPush = {
        fecha:fecha,
        nro_reserva:'st' + dateNumber + item.dni + item.nro,
        nombre_p:item.nombre,
        apellido_p:item.apellido,
        dni_p:item.dni,
        email_p:item.email,
        telefono_p:item.telefono,
        profesionales_id:selectedProfesional,
        centros_de_salud_id:selectedCentro,
        horarios_id:selectedHorario,
        obras_sociales_id:item.os,
        especialidades_id:especialidadId,
        nombre_ar:'',
        apellido_ar:''
      };

      sobreTurnosToAdd.push(sobreTurnoToPush);
    });

    this.search.pacientes.menores.forEach(function(item) {
      var sobreTurnoToPush = {
        fecha:fecha,
        nro_reserva:'st' + dateNumber + item.dni + item.nro,
        nombre_p:item.nombre,
        apellido_p:item.apellido,
        dni_p:item.dni,
        email_p:item.email,
        telefono_p:item.telefono,
        profesionales_id:selectedProfesional,
        centros_de_salud_id:selectedCentro,
        horarios_id:selectedHorario,
        obras_sociales_id:item.os,
        especialidades_id:especialidadId,
        nombre_ar: item.nombre_ar,
        apellido_ar: item.apellido_ar
      };

      sobreTurnosToAdd.push(sobreTurnoToPush);
    });

    sobreTurnosToAdd.forEach(st => {
      this.commonService.saveSobreTurno(st)
        .then(() => {
          c++;

          if (c === sobreTurnosToAdd.length) {
            alert('Sobreturnos creados correctamente');
            this.router.navigate(['/inicio']);
          }
        });
    });
  }

  public checkPacientes():boolean {
    let valid = false;
    let adultosValid = true;
    let menoresValid = true;

    this.search.pacientes.adultos.forEach(item => {
      if (!item.nombre.length || !item.apellido.length || !item.dni.length) {
        adultosValid = false;
        return;
      }
      return;
    });

    this.search.pacientes.menores.forEach(item => {
      if (!item.nombre.length || !item.apellido.length || !item.dni.length) {
        menoresValid = false;
        return;
      }
      return;
    });

    if (adultosValid && menoresValid) {
      valid = true;
    }

    return valid;
  }

  public checkST():boolean {
    let valid = false;
    let adultosValid = true;
    let menoresValid = true;

    this.search.pacientes.adultos.forEach(item => {
      if (!item.nombre.length || !item.apellido.length || !item.dni.length) {
        adultosValid = false;
        return;
      }
      return;
    });

    this.search.pacientes.menores.forEach(item => {
      if (!item.nombre.length || !item.apellido.length || !item.dni.length) {
        menoresValid = false;
        return;
      }
      return;
    });

    if (adultosValid && menoresValid && this.selectedCentro > 0 && this.selectedProfesional > 0 && this.selectedHorario > 0 && this.selectedDate) {
      valid = true;
    }

    return valid;
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/turnos/turnos.component.ts